import { render, staticRenderFns } from "./Specialists.vue?vue&type=template&id=fa3d098e&scoped=true&"
import script from "./Specialists.vue?vue&type=script&lang=js&"
export * from "./Specialists.vue?vue&type=script&lang=js&"
import style0 from "./Specialists.vue?vue&type=style&index=0&id=fa3d098e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3d098e",
  null
  
)

export default component.exports